import { render, staticRenderFns } from "./HomeMainBannerV3.vue?vue&type=template&id=b1818cd8&scoped=true&"
import script from "./HomeMainBannerV3.vue?vue&type=script&lang=js&"
export * from "./HomeMainBannerV3.vue?vue&type=script&lang=js&"
import style0 from "./HomeMainBannerV3.vue?vue&type=style&index=0&id=b1818cd8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1818cd8",
  null
  
)

export default component.exports